import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-map-marker-area-icon',
    templateUrl: './map-marker-area-icon.component.svg',
    styleUrls: ['./map-marker-area-icon.component.scss'],
    standalone: false,
})
export class MapMarkerAreaIconComponent {}
